module.exports = __webpack_public_path__ + "img/background_login.5891abcf.jpg";